import { Form, onFieldValueChange } from '@eastcoal/formily/exports/core'

import { PRICING_METHOD_FIELD, START_PRICE_FIELD } from '../../constants/field'

const KA_MAX_PRICE = 0.2
const validPriceByKa = (_: any, form: Form) => {
  const { pricingMethodName, startPrice = 0 } = form.values

  const startPriceField = form.query(START_PRICE_FIELD).take()

  if (pricingMethodName?.includes('卡')) {
    startPriceField?.setState(state => {
      state['feedbacks'] =
        startPrice > KA_MAX_PRICE
          ? [
              {
                type: 'error',
                messages: [`按卡拍，起拍价不能大于 ${KA_MAX_PRICE}`]
              }
            ]
          : []
    })
  }
}

const clearError = (_: any, form: Form) => {
  const { pricingMethodName, startPrice = 0 } = form.values

  if (!pricingMethodName?.includes('卡')) {
    if (startPrice > KA_MAX_PRICE) {
      form.clearErrors(START_PRICE_FIELD)
    }
  }
}

export const startPriceEffect = () => {
  onFieldValueChange(PRICING_METHOD_FIELD, validPriceByKa)
  onFieldValueChange(START_PRICE_FIELD, validPriceByKa)
  onFieldValueChange(PRICING_METHOD_FIELD, clearError)
}
